import {createContext, useContext, useEffect, useState} from 'react';

const TableContext = createContext<any>({});

const TableProvider = ({
    children,
    pageNumber,
    totalPageNumber,
    onPageChange
}: any) => {
    const initialSortBy = {
        id: '',
        order: '',
    };
    const [state, setState] = useState({
        sortBy: initialSortBy,
        pageNumber: 1,
        totalPageNumbers: totalPageNumber ?? 1
    });

    const setPageNumber = (pageNumber: number) => {
        setState((state) => ({
            ...state,
            pageNumber: pageNumber
        }));
        onPageChange(pageNumber);
    };

    const setTotalPageNumbers = (totalPages: number) => setState((state) => ({
      ...state,
      totalPageNumbers: totalPages
    }))

    const handleSortClick = (id: any) => {
        if (state.sortBy.id === id && state.sortBy.order === 'DESC') {
            setState((state) => ({
                ...state,
                sortBy: initialSortBy
            }));

            return;
        }

        setState((state) => ({
            ...state,
            sortBy: {
                id,
                order: state.sortBy.id !== id ? 'ASC' : 'DESC'
            }
        }));
    }

    return <TableContext.Provider
        value={{
            state,
            handleSortClick,
            setPageNumber,
            setTotalPageNumbers
        }}
    >
        { children }
    </TableContext.Provider>;
}

function TableConsumer({children}) {
    return (
      <TableContext.Consumer>
        {context => {
          if (context === undefined) {
            throw new Error('TableConsumer must be used within a TableProvider')
          }
          return children(context)
        }}
      </TableContext.Consumer>
    )
  }

function useTable() {
    const context = useContext(TableContext)
    if (context === undefined) {
        throw new Error('useCount must be used within a CountProvider')
    }

    return context;
}

export {
    TableProvider,
    TableConsumer,
    useTable
};